import { State } from '../models/state';

/**
 * Map to state model from dto.
 * @param {object} dto Dto data.
 * @returns {State}
 */
function fromDto(dto) {
  return new State({
    name: dto.name,
    stateCode: dto.state_code,
    timeZone: dto.time_zone,
  });
}

export const stateMapper = {
  fromDto,
};
